export const PATHS = {
  NONE: '',
  LOGIN: '/',
  LOGIN_ERROR: '/login-error',
  ABOUT_MFA_CODE_SENDING: '/about-mfa-code-sending',
  NOT_FOUND: '*',
  MYPAGE: '/mypage',
  AUDITION_FORM: '/form/:group/:audition_id/:examination_no',
  CONSENT_FORM_UPLOAD: '/form/:group/:audition_id/:examination_no/upload',
  CONFIRM_MFA_CODE: '/confirm-mfa-code',
  CHANGE_PASSWORD: '/change-password',
  RESET_PASSWORD: '/reset-password',
  CONFIRM_RESET_PASSWORD: '/confirm-reset-password',
  AUDITION_INFO: '/audition',
  RECRUITING_AUDITIONS: '/recruiting-auditions',
  MESSAGE: '/message',
  USER_EDIT: '/user_edit',
  USER_DELETE: '/user_delete',
  FAQ: '/faq',
  INQUIRY: '/inquiry',
  FORGET_USER_ID: '/forget-user-id',
  PRIVACY_NOTICE: '/privacy-notice',
} as const;
export type Paths = (typeof PATHS)[keyof typeof PATHS];
